import { Menu } from './../../interfaces/menu-item.interface';
import { AllDataService } from './../../services/allData/all-data.service';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
    constructor(private dataServices: AllDataService) {}
    menuItem: Menu[] = [
        {
            name: 'HOME.DISCOUNTING_CAPITALIZATION',
            imgSrc: 'assets/icons/Capitalisation icon.svg',
            routingLink: '/actualisation',
        },
        {
            name: 'HOME.SAVING',
            imgSrc: 'assets/icons/Epargne icon.svg',
            routingLink: '/epargne',
        },
        {
            name: 'HOME.IR_TAXATION',
            imgSrc: 'assets/icons/fiscalité IR icon.svg',
            routingLink: '/ir-taxation',
        },
        {
            name: 'HOME.ENR_TAXATION',
            imgSrc: 'assets/icons/droits d enregistrement icon.svg',
            routingLink: '/enr',
        },
        {
            name: 'HOME.LIFE_INSURANCE',
            imgSrc: 'assets/icons/AV icon.svg',
            routingLink: '/life-insurance',
        },
        {
            name: 'HOME.STRIPPING_AND_ANNUITY',
            imgSrc: 'assets/icons/Démembrement icon.svg',
            routingLink: '/stripping-annuity',
        },
        {
            name: 'HOME.IMMOVABLE',
            imgSrc: 'assets/icons/immobilier icon.svg',
            routingLink: '/real-state',
        },
    ];
    async ngOnInit(): Promise<void> {
        if (window.navigator.onLine) {
            await this.dataServices.exportAllData();
        }
    }
}
